import React from "react";
import { Rocket, ShieldCheck, GraphUp, Globe } from "react-bootstrap-icons";

const cards = [
  {
    icon: <Rocket />,
    title: "Launch Pathway",
    subtitle: "For new UKG implementations",
    inc : "Rapid discovery, best-practice configuration, data and integration readiness, testing, training, and go-live support.",
    outcome: "A stable, compliant, and adoption-ready UKG environment.",
  },
  {
    icon: <ShieldCheck />,
    title: "Stabilize Pathway",
    subtitle: "For recent or struggling UKG environments",
    inc : "System health assessment, configuration optimization, data and process corrections, and support model alignment.",
    outcome: "A reliable UKG environment with fewer issues and higher confidence.",
  },
  {
    icon: <GraphUp />,
    title: "Optimize Pathway",
    subtitle: "For performance improvement and insights",
    inc : "Advanced configuration, analytics, process automation, and workforce optimization.",
    outcome: "A smarter, more efficient workforce operation.",
  },
  {
    icon: <Globe />,
    title: "Scale Pathway",
    subtitle: "For enterprise growth and expansion",
    inc : "Multi-country rollout support, complex pay rules and union support, integration expansion, and change management.",
    outcome: "A scalable UKG platform that grows with your business.",
  },
];

export default function Pathways() {
  return (
    <section className="py-5">
      <div className="container">
        <h2 className="text-center fw-bold mb-4">Our Service Pathways</h2>
        <div className="row g-4">
          {cards.map((c, i) => (
            <div key={i} className="col-md-6">
              <div className="path-card">
                <div className="icon-square">{c.icon}</div>
                <h5 className="fw-bold mt-3">{c.title}</h5>
                <p className="text-primary">{c.subtitle}</p>
                <h6> <b>INCLUDES </b></h6>
                <p className="text-primary">{c.inc}</p>
                <div className="outcome-box">
                  <strong>Outcome:</strong> {c.outcome}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
